import { DEV_SITE_HOSTS } from '@seek/adv-constants';
import { siteConfig, siteNames, getLocalizedRoutes } from '@seek/melways-sites';
import type { SkuRouteObject } from 'sku';

import type { EmployerSiteName } from './types';

export const routes: SkuRouteObject[] = [{ route: '/jobs', name: 'jobs' }];

const createSites = (sites: EmployerSiteName[]) =>
  sites.map((site) => ({
    name: site,
    host: DEV_SITE_HOSTS[site],
    routes: localiseRoutesForSite(site),
  }));

const localiseRoutesForSite = getLocalizedRoutes(routes);

export const sites = createSites([
  siteNames.employer.seek.au,
  siteNames.employer.seek.nz,
  siteNames.employer.seek.hk,
  siteNames.employer.seek.th,
  siteNames.employer.seek.sg,
  siteNames.employer.seek.id,
  siteNames.employer.seek.ph,
  siteNames.employer.seek.my,
]);

export const getSiteCountry = (site: EmployerSiteName) =>
  siteConfig[site].classification.country;

export const isSiteAnz = (site: EmployerSiteName) => {
  const country = getSiteCountry(site);

  return country === 'au' || country === 'nz';
};
